import { render, staticRenderFns } from "./HistoryCountChart.vue?vue&type=template&id=a05de538&"
import script from "./HistoryCountChart.vue?vue&type=script&lang=js&"
export * from "./HistoryCountChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports